// extracted by mini-css-extract-plugin
export default {"section":"HomePage_section__lVSt2","sectionHeader":"HomePage_sectionHeader__bTSgO","sectionTitle":"HomePage_sectionTitle__cEQEP","more":"HomePage_more__-S+3H"};